/** @jsxImportSource @emotion/react */
import { useTheme } from '@mui/material/styles'
import { SidebarAtom } from '@app/state/layoutAtom'
import { motion } from 'framer-motion'
import { useAtomValue } from 'jotai'
import { sidebarContainer } from './Sidebar.style'
import SidebarFooter from './SidebarFooter'
import { SidebarLogo } from './SidebarLogo'
import { SidebarMenu } from './SidebarMenu'

export const sidebarVariants = {
  open: {
    width: 260,
  },

  closed: {
    width: 68,
  },
}

export const Sidebar = () => {
  const theme = useTheme()
  const isOpen = useAtomValue(SidebarAtom)

  return (
    <motion.div
      variants={sidebarVariants}
      animate={isOpen ? 'open' : 'closed'}
      transition={{ duration: 0.2 }}
      css={sidebarContainer({ theme })}
    >
      <SidebarLogo />
      <SidebarMenu />
      <SidebarFooter />
    </motion.div>
  )
}
